import React, { useContext, useEffect, useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { useGenericConfiguratorNavigation } from '../../hooks/navigation/useGenericConfiguratorNavigation'
import { getI18nText } from '../../services/i18nService'
import { Link } from 'gatsby'
import { buildUrl, extractDomain } from '../../services/urlService'
import {
  buildCADButtonInteractionEvent,
  publishCADButtonInteractionEvent,
} from '../../services/dataLayerService'
import DataLayerContext from '../../contexts/dataLayerContext'

const Cad = ({
  microcopy,
  cadFileStep,
  cadenasCataloguePath,
  locale,
  tacton_configurable,
  tacton_reference,
  itemVarSet,
}) => {
  const { eventApi } = useContext(DataLayerContext)
  const [cadOpen, setCadOpen] = useState(true)
  const [eventModelToPublish, setEventModelToPublish] = useState()
  const [cadUrl, setCadUrl] = useState()
  let configuratorUrl = useGenericConfiguratorNavigation(
    locale,
    tacton_configurable === 'True' && tacton_reference ? tacton_reference : null
  )

  useEffect(() => {
    let myCadUrl = null
    if (cadenasCataloguePath) {
      myCadUrl = `https://norgren-embedded.partcommunity.com?info=imi_precision${cadenasCataloguePath}&varset=`
      if (itemVarSet) {
        myCadUrl = myCadUrl + `${itemVarSet}`
      }
      myCadUrl = myCadUrl + '&partFixed=false'
    }
    setCadUrl(myCadUrl)
  }, [cadenasCataloguePath, itemVarSet])

  useEffect(() => {
    if (eventApi && eventModelToPublish) {
      publishCADButtonInteractionEvent(eventApi, eventModelToPublish)
    }
  }, [eventApi, eventModelToPublish])

  const handleClick = (e) => {
    let linkClasses = e.target.className
    let linkDomain = extractDomain(e.target.href)
    let linkId = e.target.id
    let linkUrl = e.target.href
    let linkText = e.target.textContent

    setEventModelToPublish(
      buildCADButtonInteractionEvent(linkClasses, linkDomain, linkId, linkUrl, linkText)
    )
  }

  return (
    <div className="product-details__product-data--item" id="cad">
      <p className="product-details__product-data--header font__heavy" id="button-cad">
        <button
          className={`product-details__product-data--button ${cadOpen ? '' : 'collapsed'}`}
          type="button"
          aria-expanded={cadOpen}
          onClick={() => setCadOpen(!cadOpen)}
          aria-controls="body-cad"
        >
          {getI18nText(microcopy, 'product.cad')}
        </button>
      </p>
      <Collapse in={cadOpen}>
        <div
          id="body-cad"
          className="product-details__product-data--collapse"
          aria-labelledby="button-cad"
        >
          <div className="product-details__product-data--body">
            <p> {getI18nText(microcopy, 'product.weoffercad')}</p>
            <div className="product-details__product-data--links d-flex flex-wrap mt-5">
              {cadUrl ? (
                <a
                  href={cadUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-rebrand text-uppercase"
                  onClick={handleClick}
                >
                  <div className="d-flex justify-content-center align-items-center">
                    <i className="icon-Btn-Arrow"></i>
                    <span>{getI18nText(microcopy, 'product.cadmodel')}</span>
                  </div>
                </a>
              ) : null}
              {cadFileStep ? (
                <a
                  href={'https://cdn.norgren.com/cad-step/' + cadFileStep}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-rebrand text-uppercase"
                >
                  <div className="d-flex justify-content-center align-items-center">
                    <i className="icon-Btn-Arrow"></i>
                    <span>
                      {getI18nText(microcopy, 'product.cad')} (
                      {getI18nText(microcopy, 'product.step')})
                    </span>
                  </div>
                </a>
              ) : null}
              {configuratorUrl ? (
                <Link to={buildUrl(configuratorUrl, '')} className="btn btn-rebrand text-uppercase">
                  <div className="d-flex justify-content-center align-items-center">
                    <i className="icon-Btn-Arrow"></i>
                    <span>{getI18nText(microcopy, 'product.configurator')}</span>
                  </div>
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default Cad
